<template>
  <div class="recharge-page">
    <!-- ============ 余额卡片 ============ -->
    <el-card shadow="never" class="balance-card">
      <div class="balance-row">
        <div class="balance-left">
          <div class="balance-label">当前找客点</div>
          <div class="balance-num">
            {{ user ? user.balance_points : 0 }}
            <span class="unit">点</span>
          </div>
          <div class="balance-sub" v-if="user">
            <template v-if="user.plan_id && memberOf">
              当前会员：<b>{{ memberOf.name }}</b>
              <template v-if="user.plan_expire"> · 至 {{ user.plan_expire }}</template>
              <br />
            </template>
            找客点有效期至 {{ user.points_expire || '—' }}
          </div>
        </div>
        <div class="balance-right">
          <div class="balance-user">{{ user ? user.nickname : '未登录' }}</div>
          <div class="balance-phone">{{ user ? user.phone : '' }}</div>
          <el-button v-if="!user" type="primary" @click="$router.push('/login')">去登录</el-button>
          <el-button v-else type="danger" plain size="small" @click="logout">退出</el-button>
        </div>
      </div>
    </el-card>

    <!-- ============ 会员卡（三档） ============ -->
    <el-card shadow="never" class="mt-16">
      <template #header>
        <div class="card-header">
          <span>👑 AI 会员 <span class="slogan">全功能解锁 · 每月送积分 · 视频折扣（会员积分当月有效）</span></span>
        </div>
      </template>
      <el-row :gutter="12">
        <el-col :xs="24" :sm="8" :md="8" v-for="p in memberPlans" :key="p.id" style="margin-bottom:12px">
          <div class="plan-card member" :class="{ pro: p.id === 8 }">
            <div class="plan-name">{{ p.name }}</div>
            <div class="plan-price">
              ¥{{ p.first_month_price && p.first_month_price < p.price ? p.first_month_price : p.price }}
              <span class="unit" v-if="p.first_month_price && p.first_month_price < p.price">/月（首月特价，原 {{ p.price }}）</span>
              <span class="unit" v-else>/月</span>
            </div>
            <div class="plan-points">
              每月送 <b style="color:#f59e0b">{{ p.monthly_points }}</b> 点
              <span v-if="p.video_discount < 1" class="bonus">· AI视频 {{ p.video_discount * 10 }} 折</span>
            </div>
            <div class="plan-desc">{{ p.desc }}</div>
            <el-button type="primary" size="small" style="width:100%" :loading="paying === p.id" @click="buy(p)">
              {{ user && user.plan_id === p.id ? '续费会员' : '开通会员' }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- ============ 充值卡（五档） ============ -->
    <el-card shadow="never" class="mt-16">
      <template #header>
        <div class="card-header">
          <span>💳 充值找客点 <span class="slogan">不用包月，按需付费（1点=1元，有效期365天）</span></span>
        </div>
      </template>

      <el-row :gutter="12">
        <el-col :xs="12" :sm="8" :md="8" v-for="p in pointsPlans" :key="p.id" style="margin-bottom:12px">
          <div class="plan-card" :class="{ hot: p.bonus > 0 }">
            <div class="plan-name">{{ p.name }}</div>
            <div class="plan-price">¥{{ p.price }}</div>
            <div class="plan-points">
              {{ p.points + p.bonus }} 找客点
              <span v-if="p.bonus" class="bonus">（含赠 {{ p.bonus }}）</span>
            </div>
            <div class="plan-desc">{{ p.desc }}</div>
            <el-button type="primary" size="small" style="width:100%" :loading="paying === p.id" @click="buy(p)">
              立即充值
            </el-button>
          </div>
        </el-col>
      </el-row>

      <el-divider content-position="left">企业定制</el-divider>
      <div class="plan-card monthly">
        <div class="plan-name">🏢 企业定制</div>
        <div class="plan-price">面议<span class="unit">（1点=1元）</span></div>
        <div class="plan-points">多账号矩阵 · 全自动 · 专属服务</div>
        <div class="plan-desc">专属词库 + 定制话术 · 私有化部署 / OEM 贴牌 · 专属顾问陪跑 · 按企业用量专属报价</div>
        <el-button type="primary" size="small" style="width:100%" @click="contactCustom">
          联系顾问定制
        </el-button>
      </div>
    </el-card>

    <!-- ============ 消费明细 ============ -->
    <el-card shadow="never" class="mt-16">
      <template #header>
        <div class="card-header">
          <span>📒 找客点流水</span>
          <el-button size="small" text type="primary" @click="loadRecords">刷新</el-button>
        </div>
      </template>
      <el-table :data="records" size="small" stripe>
        <el-table-column prop="created_at" label="时间" width="140" />
        <el-table-column label="项目" min-width="180">
          <template #default="{ row }">{{ actionName(row.action) }} {{ row.note }}</template>
        </el-table-column>
        <el-table-column label="变动" width="100" align="right">
          <template #default="{ row }">
            <span :class="row.change >= 0 ? 'plus' : 'minus'">{{ row.change >= 0 ? '+' : '' }}{{ row.change }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="余额" width="80" align="right" />
      </el-table>
      <el-empty v-if="!records.length" description="暂无流水" :image-size="60" />
    </el-card>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Recharge',
  data() {
    return {
      user: null,
      plans: [],
      records: [],
      paying: 0
    }
  },
  computed: {
    pointsPlans() {
      return this.plans.filter(p => p.kind === 'points')
    },
    memberPlans() {
      return this.plans.filter(p => p.kind === 'member')
    },
    memberOf() {
      if (!this.user || !this.user.plan_id) return null
      return this.plans.find(p => p.id === this.user.plan_id) || null
    }
  },
  created() {
    this.loadUser()
    this.loadPlans()
    this.loadRecords()
  },
  methods: {
    loadUser() {
      try {
        this.user = JSON.parse(localStorage.getItem('current_user') || 'null')
      } catch (e) { this.user = null }
      if (this.user) {
        api.get('/auth/me', { params: { user_id: this.user.id } }).then(r => {
          this.user = r.user
          localStorage.setItem('current_user', JSON.stringify(r.user))
        }).catch(() => {})
      }
    },
    async loadPlans() {
      try {
        const r = await api.get('/plans')
        this.plans = r.plans || []
      } catch (e) { console.error(e) }
    },
    async loadRecords() {
      if (!this.user) return
      try {
        const r = await api.get('/point-records', { params: { user_id: this.user.id, limit: 20 } })
        this.records = r.records || []
      } catch (e) { console.error(e) }
    },
    actionName(a) {
      return {
        recharge: '充值', video_gen: 'AI视频', video_refund: '退款',
        collect: '采集', dm: '私信', marketing: '营销军师', five_sets: '五件套'
      }[a] || a
    },
    async buy(p) {
      if (!this.user) {
        this.$message.warning('请先登录')
        this.$router.push('/login')
        return
      }
      this.paying = p.id
      try {
        const r = await api.post('/orders/create', { user_id: this.user.id, plan_id: p.id })
        const order = r.order
        let msg
        if (order.plan_kind === 'member') {
          msg = `确认支付 ¥${order.amount} 开通「${order.plan_name}」？\n每月送 ${order.monthly_points} 点（当月有效）` +
                (order.video_discount < 1 ? `，AI 视频 ${order.video_discount * 10} 折` : '') +
                `\n（测试模式，直接到账）`
        } else {
          msg = `确认支付 ¥${order.amount} 购买「${order.plan_name}」？\n到账 ${order.points} 找客点（测试模式，直接到账）`
        }
        this.$confirm(msg, '支付确认', { confirmButtonText: '确认支付', cancelButtonText: '取消', type: 'warning' }
        ).then(async () => {
          const pr = await api.post('/orders/pay?order_id=' + order.id, {})
          this.$message.success(`支付成功！${order.plan_kind === 'member' ? '会员已开通' : '到账 ' + pr.points + ' 点'}，当前余额 ${pr.balance} 点`)
          this.loadUser()
          this.loadRecords()
        }).catch(() => {})
      } catch (e) {
        this.$message.error(e.message || '创建订单失败')
      } finally {
        this.paying = 0
      }
    },
    logout() {
      localStorage.removeItem('current_user')
      localStorage.removeItem('user_id')
      localStorage.removeItem('user_phone')
      this.user = null
      this.records = []
      this.$message.success('已退出登录')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.balance-card {
  background: linear-gradient(135deg, #2563EB 0%, #1e40af 100%);
  color: #fff;
}
.balance-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.balance-label { font-size: 15px; opacity: 0.9; }
.balance-num { font-size: 44px; font-weight: 800; margin: 4px 0; }
.balance-num .unit { font-size: 17px; font-weight: 400; }
.balance-sub { font-size: 14px; opacity: 0.85; }
.balance-right { text-align: right; }
.balance-user { font-size: 17px; font-weight: 600; }
.balance-phone { font-size: 14px; opacity: 0.8; margin-bottom: 6px; }
.card-header { display: flex; align-items: center; justify-content: space-between; }
.slogan { font-size: 14px; color: #e6a23c; margin-left: 8px; }
.plan-card {
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 16px;
  text-align: center;
  transition: all 0.2s;
  height: 100%;
}
.plan-card:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.08); }
.plan-card.hot { border-color: #f59e0b; background: #1a2438; }
.plan-card.monthly { border-color: #2563EB; background: #16203a; padding: 20px; text-align: center; }
.plan-card.member { border-color: #2563EB; background: #141f3d; }
.plan-card.member.pro { border-color: #f59e0b; background: linear-gradient(180deg, #1d2a4d 0%, #141f3d 100%); }
.plan-card.member.pro .plan-name { color: #f59e0b; }
.plan-name { font-weight: 600; font-size: 17px; color: #e2e8f0; }
.plan-price { font-size: 30px; font-weight: 800; color: #f59e0b; margin: 8px 0; }
.plan-card.hot .plan-price, .plan-card.monthly .plan-price { color: #f59e0b; }
.plan-price .unit { font-size: 15px; font-weight: 400; color: #909399; }
.plan-points { color: #606266; font-size: 15px; margin-bottom: 4px; }
.bonus { color: #e6a23c; font-size: 14px; }
.plan-desc { color: #909399; font-size: 14px; margin-bottom: 10px; min-height: 18px; }
.plus { color: #67c23a; font-weight: 600; }
.minus { color: #f56c6c; font-weight: 600; }
.mt-16 { margin-top: 16px; }
/* 手机端优化 */
@media (max-width: 767px) {
  .balance-card { padding: 8px; }
  .balance-num { font-size: 32px; }
  .plan-card { padding: 12px 8px; }
  .plan-price { font-size: 22px; }
  .el-card__body { padding: 12px; }
  .el-table { overflow-x: auto; }
}
</style>
